import { render, staticRenderFns } from "./TenantParameter.vue?vue&type=template&id=b0edb28a&"
import script from "./TenantParameter.vue?vue&type=script&lang=js&"
export * from "./TenantParameter.vue?vue&type=script&lang=js&"
import style0 from "./TenantParameter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports